import { cn } from "@lib/cn";
import type { CSSProperties } from "react";

export const GifSkeleton = ({
  noAnim,
  style,
}: {
  noAnim?: boolean;
  style?: CSSProperties;
}) => {
  return (
    <div
      className={cn(
        "tw-h-full tw-w-full tw-rounded tw-bg-blue-50",
        !noAnim && "tw-animate-skeleton-loading",
      )}
      style={style}
    />
  );
};
